import { useState } from "react";

export default function useModal () {
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(prev => !prev);
  
    return { modal, setModal, toggle };
}